const getRgbColor = (color: any): string => {
  const { rgb: { r, g, b, a } } = color;
  return `rgba(${r},${g},${b},${a})`;
};

export default getRgbColor;
